import type { ThemeDefinition } from 'vuetify';
import { VBtn } from 'vuetify/components';
export const SeventyTwoTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#cb4848',
    secondary: '#9999',
    success: '#1c611eff',
    warning: '#ff9800',
    error: '#831a12ff',
    background: '#f5f5f5',
    surface: '#ffffff',
    heading: '#555555',
  },
};

export const vuetifySettings = {
  theme: {
    defaultTheme: 'SeventyTwoTheme',
    themes: {
      SeventyTwoTheme: SeventyTwoTheme,
    },
  },
  aliases: {
    FullWidthButton: VBtn,
    FullSecondaryButton: VBtn,
    ActionButton: VBtn,
  },
  defaults: {
    VBtn: {
      color: 'primary',
      variant: 'flat',
      rounded: 'lg',
      size: 'large',
      elevation: 2,
    },
    FullWidthButton: {
      color: 'primary',
      block: true,
      variant: 'flat',
      rounded: 'lg',
      size: 'large',
      elevation: 2,
    },
    ActionButton: {
      color: 'primary',
      variant: 'text',
      rounded: 'lg',
      size: 'small',
    },
    FullSecondaryButton: {
      color: 'secondary',
      block: true,
      variant: 'flat',
      rounded: 'lg',
      size: 'large',
      elevation: 2,
    },
    VCard: {
      rounded: 'lg',
      elevation: 2,
      class: 'fill-height info_card',
      variant: 'flat',
    },
    VSelect: {
      variant: 'solo',
      density: 'comfortable',
    },
    VTextField: {
      variant: 'solo',
      density: 'comfortable',
    },
  },
};
